import { Injectable, Signal, WritableSignal, signal } from '@angular/core';

/**
 * Whether TTMS has refused the signed-in user, and why.
 *
 * <p>Set by {@link TmsAccessInterceptor} from TTMS's 403 "No TTMS access" answer and
 * cleared by its next successful answer. TmsLayoutComponent shows one "No Trovata TMS access"
 * panel over the TMS page, so a refused user sees one explanation instead of whichever screen
 * error ("Failed to load profiles.", "Failed to bootstrap dashboard.") lost the race.
 */
@Injectable({ providedIn: 'root' })
export class TmsAccessService {
	private readonly deniedMessage: WritableSignal<string | null> = signal<string | null>(null);

	/** The refusal message, or null while TTMS is answering normally. */
	readonly denied: Signal<string | null> = this.deniedMessage.asReadonly();

	setDenied(message: string): void {
		this.deniedMessage.set(message);
	}

	clear(): void {
		this.deniedMessage.set(null);
	}
}
